import { mq, pxToRem, sizes } from 'src/theme'
import styled from 'styled-components'

import Icon from '../Icon'
import Picture from '../Picture'

export const Container = styled.figure`
  --illustration-width__toggle: ${pxToRem(32)};
  display: flex;
  position: relative;
  overflow: hidden;
  @media ${mq(sizes.desktop)} {
    --illustration-width__toggle: ${pxToRem(48)};
  }
`
export const Content = styled.div`
  position: absolute;
  inset-block-end: -1px;
  inset-inline-end: 0;
  display: flex;
  flex-flow: row;
  align-items: center;
  max-width: 90%;
  min-height: var(--illustration-width__toggle);

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: ${({ theme }) => theme.colors.white};
    transform: translateX(calc(100% - var(--illustration-width__toggle)));
    transition: transform 0.5s ease-in-out;
  }

  &[data-open='true'] {
    &::before {
      transform: translateX(0);
      transition: transform 0.5s ease-in-out;
    }
  }
`
export const Toggle = styled.button`
  position: absolute;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1;
  width: var(--illustration-width__toggle);
  background-color: transparent;
  opacity: 0;
`
export const Open = styled(Toggle)`
  inset-inline-end: 0;
  visibility: visible;
  transform: translateX(0);
  transition:
    opacity 0.1s 0.4s,
    transform 0.1s 0.4s,
    visibility 0s 0.4s;
  ${Content}[data-open='true'] & {
    opacity: 0;
    visibility: hidden;
    transform: translateX(-50%);
    transition:
      opacity 0.1s,
      transform 0.1s,
      visibility 0s 0.1s;
  }
  ${Content}:not([data-open='true']) & {
    opacity: 1;
  }
`
export const Close = styled(Toggle)`
  inset-block-end: 0;
  inset-inline-end: 0;
  visibility: hidden;
  opacity: 0;
  transform: translateX(50%);
  transition:
    opacity 0.3s ease-in,
    transform 0.3s ease-in,
    visibility 0s 0.3s;

  ${Content}[data-open= 'true'] & {
    visibility: visible;
    opacity: 1;
    transform: translateX(0);
    transition:
      opacity 0.2s ease-out 0.3s,
      transform 0.2s ease-out 0.3s,
      visibility 0s;
  }
`
export const _Icon = styled(Icon)`
  aspect-ratio: 1;
  width: ${pxToRem(24)};
`
export const OpenIcon = styled(_Icon)``
export const CloseIcon = styled(_Icon)``
export const Caption = styled.figcaption`
  ${({ theme }) => theme.textStyles.m375_bodySmall}
  position: relative;
  z-index: 1;
  display: block;
  overflow: hidden;
  width: max-content;
  padding-block: ${pxToRem(4)};
  padding-inline: ${pxToRem(16)} calc(var(--illustration-width__toggle));
  clip-path: polygon(100% 0, 100% 0, 100% 100%, 100% 100%);
  opacity: 0;
  transition:
    opacity 0.5s ease-in-out,
    clip-path 0.5s ease-in-out;
  ${Content}[data-open='true'] & {
    opacity: 1;
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
    transition:
      opacity 0.5s ease-in-out,
      clip-path 0.5s ease-in-out;
  }
`

export const _Picture = styled(Picture)`
  width: 100%;
`
